module.exports = __webpack_public_path__ + "img/3.8637a84b.png";